/* global UC_UI */

import { useContext, useEffect } from 'react';
import { navigate, Script } from 'gatsby';
import { GlobalStateContext } from '../../scripts/GlobalContextProvider';
import { isIframe, getIframeOptions } from '../../scripts/utils';
import { useIsClient } from '../../scripts/hooks';
import MapPatterns from '../MapPatterns';
import Loader from '../Loader';
import Header from '../Header';
import Footer from '../Footer';
import Map from '../Map';
import FilterRegion from '../FilterRegion';
import Timeline from '../Timeline';
import useDataOrchestrator from '../../scripts/useDataOrchestrator';

// Styles
import './index.scss';

const Layout = ({ children, pageContext, location }) => {
  const { region } = useContext(GlobalStateContext);
  const { pageData } = pageContext;
  const isClient = useIsClient();
  const iframeOptions = isClient ? getIframeOptions() : { header: true, stories: true, footer: true };

  useDataOrchestrator({ pageData });

  const embedAnalytics = () => {
    if (typeof UC_UI !== 'undefined' && UC_UI.getServicesBaseInfo().find((item) => item.name.includes('Google Analytics 4'))?.consent.status) {
      return <Script src="https://www.google-analytics.com/analytics.js" async />
    }

    return null;
  }

  const scriptTags = isClient && !isIframe() ? (
    <>
      {embedAnalytics()}
      <Script async>
        {`
          (function(w,d,s,l,i){
          w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),
              dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;j.src='https://server.eon.de/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-NDBX2F4');
        `}
      </Script>
    </>
  ) : null;

  useEffect(() => {
    if (location.pathname === '/') {
      navigate(pageData.pathWithNewestStory);
    }
  }, [location.pathname, pageData]);

  if (pageContext.layout === '404') {
    return children;
  }

  const showTimeline = region !== 2;
  const showRegionFilter = Boolean(pageData.meta.regionFilters);

  return (
    <section className={['layout', !iframeOptions.stories && 'layout--no-stories'].filter(Boolean).join(' ')} suppressHydrationWarning>
      {scriptTags}
      <MapPatterns />
      <Loader />
      {iframeOptions.header && <Header />}
      <main className="layout__main">
        {children}
        <div className="layout__map">
          <Map pageData={pageData} />
          <div className={['layout__wrapper', !iframeOptions.stories && 'layout__wrapper--no-stories'].filter(Boolean).join(' ')}>
            {showTimeline && <Timeline />}
            {showRegionFilter && <FilterRegion regionFilters={pageData.meta.regionFilters} />}
          </div>
        </div>
      </main>
      {iframeOptions.footer && <Footer />}
    </section>
  );
};

export default Layout;